import { ValidationProps, ValidationLevel } from 'ui/common/validation/types';

export const hasValidationErrors = (validation: { [key: string]: ValidationProps }) => {
  return Object.keys(validation)
    .filter(validationKey => !!validation[validationKey])
    .some(validationKey => validation[validationKey].level === ValidationLevel.error);
};
